<template lang="pug">
modelView(ref='modelView')
</template>

<script>
/**
 * 警告 ！！
 * 请不要格式化文档，本来可读性很强了，不要很简单的组件整好几十行 ！！！
 * 对应组件的功能写到对应组件上，不明白别乱写，搞得看不懂我找你 ！！！
 */
import modelView from "./component/modelLoad.vue";
// import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

export default {
  components: { modelView },
  created() {
    this.initEvent();
  },
  methods: {
    // 初始化监听事件
    initEvent() {
      // mongeApiMlib.initEvent();
    }
  }
};
</script>
